module.exports = __webpack_public_path__ + "d485d47f0d604c46e6cd81a836f74814.png";